export default async (params = {}) => {
  const media = params.social_media;
  let _return = "",
    buttons = [];
  if (redes.length === 0) {
    return "Não possuímos redes sociais.";
  } else {
    if (media) {
      const rede = redes.filter(i => {
        if (i.cl !== "envelope") {
          buttons.push({ color: "error darken-2", text: i.cl, action: i.url });
        }
        if (i.cl.includes(media.toLowerCase())) {
          return i;
        }
      });
      if (media !== "Rede Social") {
        if (rede.length > 0) {
          const link = rede[0].url;
          _return = `Nosso <strong>${media}</strong> é <a class="text-primary" href="${link}" target="_blank">${link}</a><br>`;
        } else {
          _return = "Não possuímos <strong>" + media + "</strong>.<br>";
        }
      }
    }
    if (redes.length > 0) {
      _return += "Confira todas nossas redes sociais.";
    }
    return { msg: _return, buttons };
  }

}
